/* HEARTBOOK: nút Quick add trên thẻ sản phẩm hb-card-product (26/09/2026).
   Nguồn: brands/heartbook/store/site-vibe-2026-09-26/ trong HQ-Groups. Sửa ở đó rồi đẩy lên.
   - Sản phẩm 1 bản: bấm là thêm 1 cuốn vào giỏ rồi mở ngăn giỏ.
   - Nhiều bản: mở bảng chọn mẫu (ảnh + tên + giá), bấm mẫu nào thêm mẫu đó.
   - Gửi kèm gói pre-order Timesact (data-selling-plan / "plan"), như khối mua kèm.
   - Thứ tự như nút mua Shrine: phát cartUpdate TRƯỚC rồi mới vẽ ngăn giỏ (lỗi 26/09: vẽ trước thì ngăn giỏ hiện HTML trang /cart).
   - Shrine (main.js 218 KB, có lúc tải rất chậm) chưa sẵn sàng: thêm giỏ xong chuyển sang trang /cart, khách vẫn mua được.
   - Nghe bấm trên cả trang: lưới vẽ lại sau khi lọc / sắp xếp vẫn chạy. Nạp async. */
(() => {
  if (window.__hbQuickAdd) return;
  window.__hbQuickAdd = true;

  const LABELS = { adding: 'Adding', added: 'Added', error: 'Try again' };
  const cartUrl = () => (window.routes && window.routes.cart_url) || '/cart';

  const sectionIds = () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') return drawer.getSectionsToRender().map((s) => s.id);
    return ['cart-icon-bubble'];
  };

  const setState = (el, state) => {
    el.dataset.state = state;
    const label = el.querySelector('[data-label]');
    if (label) label.textContent = LABELS[state] || label.dataset.label;
  };

  async function addToCart(id, plan, from) {
    const body = { id: Number(id), quantity: 1, sections: sectionIds(), sections_url: window.location.pathname };
    if (plan) body.selling_plan = Number(plan);
    const root = (window.routes && window.routes.cart_add_url) || '/cart/add';
    const res = await fetch(`${root}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Cart error');

    const drawer = document.querySelector('cart-drawer');
    const shrineReady = typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && drawer && typeof drawer.renderContents === 'function' && data.sections;
    if (!shrineReady) {
      window.location.href = cartUrl();
      return data;
    }
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hb-quick-add', productVariantId: body.id, cartData: data });
    if (typeof drawer.setActiveElement === 'function' && from) drawer.setActiveElement(from);
    drawer.classList.remove('is-empty');
    drawer.renderContents(data); // mở ngăn giỏ như nút mua trên trang sản phẩm
    return data;
  }

  // ---------- bảng chọn mẫu ----------
  let sheet;
  let opener;
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const ICONS =
    '<svg class="hb-i hb-i--bag" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5 8h14l-1 12H6L5 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/><path d="M12 11.5v5M9.5 14h5"/></svg>' +
    '<svg class="hb-i hb-i--spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 3a9 9 0 1 1-9 9"/></svg>' +
    '<svg class="hb-i hb-i--check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function buildSheet() {
    sheet = document.createElement('div');
    sheet.className = 'hb-qa';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="hb-qa__overlay" data-hb-qa-close></div>' +
      '<div class="hb-qa__panel" role="dialog" aria-modal="true" aria-labelledby="HbQaTitle">' +
      '<div class="hb-qa__head"><div class="hb-qa__heading"><h2 class="hb-qa__title" id="HbQaTitle"></h2><p class="hb-qa__option"></p></div>' +
      '<button type="button" class="hb-qa__close" data-hb-qa-close aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="hb-qa__list"></div>' +
      '<p class="hb-qa__error" role="alert" hidden></p>' +
      '</div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', (e) => {
      if (e.target.closest('[data-hb-qa-close]')) closeSheet();
      const opt = e.target.closest('.hb-qa__opt');
      if (opt && !opt.disabled) chooseOption(opt);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet();
    });
  }

  function openSheet(btn) {
    let cfg;
    // thẻ sản phẩm, hoặc khối khác có nút Quick add (29/09: khối tiêu điểm trang chủ hb-spotlight, đánh dấu data-hb-qa-root)
    const root = btn.closest('.hb-card, [data-hb-qa-root]');
    try {
      cfg = JSON.parse(root.querySelector('[data-hb-card-options]').textContent);
    } catch (e) {
      window.location.href = root.querySelector('a').href; // không đọc được dữ liệu: sang trang sản phẩm
      return;
    }
    if (!sheet) buildSheet();
    opener = btn;
    sheet.querySelector('.hb-qa__title').textContent = cfg.title;
    sheet.querySelector('.hb-qa__option').textContent = cfg.option || '';
    sheet.querySelector('.hb-qa__error').hidden = true;
    sheet.querySelector('.hb-qa__list').innerHTML = cfg.variants
      .map(
        (v) =>
          `<button type="button" class="hb-qa__opt" data-id="${esc(v.id)}"${v.plan ? ` data-plan="${esc(v.plan)}"` : ''} data-state=""${v.available ? '' : ' disabled'}>` +
          `<span class="hb-qa__thumb">${v.img ? `<img src="${esc(v.img)}" alt="" loading="lazy">` : ''}</span>` +
          `<span class="hb-qa__text"><span class="hb-qa__name">${esc(v.title)}</span>` +
          `<span class="hb-qa__price">${esc(v.price)}${v.compare ? ` <s>${esc(v.compare)}</s>` : ''}</span></span>` +
          `<span class="hb-qa__go">${ICONS}<span data-label="${v.available ? 'Add' : 'Sold out'}">${v.available ? 'Add' : 'Sold out'}</span></span>` +
          '</button>'
      )
      .join('');
    sheet.hidden = false;
    document.documentElement.classList.add('hb-qa-open');
    const first = sheet.querySelector('.hb-qa__opt:not([disabled])');
    (first || sheet.querySelector('.hb-qa__close')).focus({ preventScroll: true });
  }

  function closeSheet(keepFocus) {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    document.documentElement.classList.remove('hb-qa-open');
    if (!keepFocus && opener) opener.focus({ preventScroll: true });
  }

  async function chooseOption(opt) {
    if (opt.dataset.state === 'loading') return;
    setState(opt, 'loading');
    try {
      await addToCart(opt.dataset.id, opt.dataset.plan, opener);
      setState(opt, 'added');
      closeSheet(true);
    } catch (err) {
      console.error('[hb-quick-add]', err);
      setState(opt, 'error');
      const msg = sheet.querySelector('.hb-qa__error');
      msg.textContent = err.message || 'Could not add to cart. Please try again.';
      msg.hidden = false;
    }
  }

  // ---------- nút trên thẻ ----------
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest && e.target.closest('[data-hb-quick-add]');
    if (!btn || btn.disabled) return;
    if (btn.hasAttribute('data-choose')) {
      openSheet(btn);
      return;
    }
    if (btn.dataset.state === 'loading') return;
    clearTimeout(btn._hbReset);
    setState(btn, 'loading');
    try {
      await addToCart(btn.dataset.variantId, btn.dataset.sellingPlan, btn);
      setState(btn, 'added');
    } catch (err) {
      console.error('[hb-quick-add]', err);
      setState(btn, 'error');
    }
    btn._hbReset = setTimeout(() => setState(btn, ''), 2400);
  });
})();
